(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("HstRtcEngine", [], factory);
	else if(typeof exports === 'object')
		exports["HstRtcEngine"] = factory();
	else
		root["HstRtcEngine"] = factory();
})(window, function() {
return 